import { render, staticRenderFns } from "./RegisterHero.vue?vue&type=template&id=3930c7e1&scoped=true&"
import script from "./RegisterHero.vue?vue&type=script&lang=js&"
export * from "./RegisterHero.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHero.vue?vue&type=style&index=0&id=3930c7e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930c7e1",
  null
  
)

export default component.exports